var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reports"},[(_vm.reports.length)?_c('ReportList',{attrs:{"reports":_vm.reports}}):_c('div',{staticClass:"reports__empty"},[_c('p',[_c('span',[_vm._v("Obecnie nie ma żadnych zgłoszeń")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }